import cryptoMd5 from 'crypto-md5';
import {constyjyp} from './constyjyp';

export const formatDataToUrl = function(data, urlP) {
    if (typeof (data) == "string") {
        return urlP + "/" + data;
    }
    if (typeof (data) == "object") {
        var args = "?";
        if (urlP.split('?').length > 1) {
            args = "&";
        }
        var i = 0;
        for (var key in data) {
            i++;
            if (i == Object.keys(data).length) {
                args = args + key + "=" + data[key];
            } else {
                args = args + key + "=" + data[key] + "&";
            }
        }
        return urlP + args;
    }
}
export const getCookie = function (name) {
  if (name != null) {
    var value = new RegExp("(?:^|; )" + encodeURIComponent(String(name)) + "=([^;]*)").exec(document.cookie);
    return value ? decodeURIComponent(value[1]) : null;
  }
};

export const setCookie = function (name, value, seconds, path) {
  var name = encodeURIComponent(name);
  var value = encodeURIComponent(value);
  var expires = new Date();
  expires.setTime(expires.getTime() + seconds * 1000);
  path = path == "" ? "/" : ";path=/";
  _expires = (typeof hours) == "string" ? "" : ";expires=" + expires.toUTCString();
  document.cookie = name + "=" + value + _expires + path;
};

//删除cookie
export const deleteCookie = function (name, path) {
  var name = encodeURIComponent(name);
  var expires = new Date(0);
  path = path == "" ? "/" : ";path=/";
  document.cookie = name + "=" + ";expires=" + expires.toUTCString() + path;
};

export const getUserInfo = function () {
  var userInfo = getLocalStorage(constyjyp.USER_INFO);
//   console.log(userInfo);
  if (userInfo) {
    return userInfo;
  }
  return '';
};

export const getDeptCode = function () {
  let deptCode = getUserInfo() ? getUserInfo().x_deptCode : '';
  if (deptCode) {
    return deptCode;
  }
  return '';
};
export const getDeptName = function () {
    let deptName = getUserInfo() ? getUserInfo().x_deptName : '';
    if (deptName) {
      return deptName;
    }
    return '';
  };


export const getAPPInfo = function () {
    var appInfo = getLocalStorage(constyjyp.APPINFO);
    if (appInfo) {
        return appInfo;
    }
    return '';
};

export const getLMSDomain = function () {
    var lmsDmain = getAPPInfo() ? getAPPInfo().lmsDomain : '';
    if (lmsDmain) {
        return lmsDmain.split(',')[0];
    } else {
        return '';
    }
};
export const getCommonDomain = function () {
    var domain = getAPPInfo() ? getAPPInfo().domain : '';
    if (domain) {
        return domain.split(',')[1];
    } else {
        return '';
    }
};
export const getSpaceDomain = function () {
    var domain = getAPPInfo() ? getAPPInfo().domain : '';
    if (domain) {
        return domain.split(',')[1]+'/person';
    } else {
        return '';
    }
};
export const getDomain = function () {
    var domain = getAPPInfo() ? getAPPInfo().domain : '';
    if (domain) {
        return domain.split(',')[0];
    } else {
        return '';
    }
};
export const getCMSDomain = function () {
    var cmsDomain = getAPPInfo() ? getAPPInfo().cmsDomain : '';
    if (cmsDomain) {
        return cmsDomain.split(',')[0];
    } else {
        return '';
    }
};
export const geTopTitle = function () {
    var topTitle = getAPPInfo() ? getAPPInfo().topTitle : '';
    if (topTitle) {
        return topTitle;
    } else {
        return '';
    }
};
export const getFriendHref = function () {
    var friendHref = getAPPInfo() ? getAPPInfo().friendHref : '';
    if (friendHref) {
        return friendHref;
    } else {
        return '';
    }
};
export const getLoginFooter = function () {
    var loginFooter = getAPPInfo() ? getAPPInfo().loginFooter : '';
    if (loginFooter) {
        return loginFooter;
    } else {
        return '';
    }
};
export const getKefuPhone = function () {
    var kefuPhone = getAPPInfo() ? getAPPInfo().kefuPhone : '';
    if (kefuPhone) {
        return kefuPhone;
    } else {
        return '';
    }
};

export const getAppId = function () {
  var appIds = getUserInfo() ? getUserInfo().x_appIds : '';
  if (appIds) {
    return appIds.split(',')[0];
  } else {
    return 'APPY041';
  }
};

export const getIsOld = function () {
    let isOld = this.getLocalStorage(constyjyp.ISOLD)||'';
    return isOld;
}

export const getJti = function () {
    var jti = getUserInfo() ? getUserInfo().jti : '';
    if (jti) {
        return jti;
    } else {
        return '';
    }
};
export const getUserId = function () {
  var userId = getUserInfo() ? getUserInfo().x_userId : '';
  if(userId){
      return userId;
  }
    return '';
};



export const getLocalStorage = function (item) {
  var data = window.localStorage.getItem(item);
  var obj = JSON.parse(data);
  if(obj && obj.localStorageitem){
      obj = obj.localStorageitem;
  }
  return obj;
};


export const setLocalStorage = function (itemName, item) {
    var obj;
    if(!item) return;
    if(typeof item == 'object'){
      obj = JSON.stringify(item); //转化为JSON字符串
    }else{
      obj = JSON.stringify({"localStorageitem":item});
    }
    window.localStorage.setItem(itemName, obj);
  return obj;
};

export const removeLocalStorage = function (itemName) {
  localStorage.removeItem(itemName);
};

export const getSignWithUrl = function (urlp) {
  var appKey = "2ecadzFRwkJ7QguQRG0";
  var appSecret = "045a6d4a3c0c440fb9787891440d525c";
  var timestamp = parseInt(new Date().getTime() / 1000 / 60);
  var sig = cryptoMd5(appKey + appSecret + timestamp,'hex');
  var string_sig = '';
    if(urlp.includes('?')){
        string_sig = '&appKey=' + appKey + '&timestamp=' + timestamp + '&sig=' + sig;
    }else{
        string_sig = '?appKey=' + appKey + '&timestamp=' + timestamp + '&sig=' + sig;
    }
  return urlp + string_sig;
}
export const getRSAString = function (value) {
    const NodeRSA = require('node-rsa');
    const otherKey = new NodeRSA('-----BEGIN PUBLIC KEY-----\n'+
        'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjaKvPo5od78knfL7bYuUUDvXeAjlO9/P\n' +
        'UqrQPDiPt7YJrh6GRyUAo56ypnCIsWMRUbUUKZnKS/9ASI/EvOC3ivRmAxIJfh0Ox07PZNS4DbLL\n' +
        '+7wmSVk8vogIEpjQ9nF9v1BsK/EyEHNiMi1NsDIAbfblGumJQ7BXZG+tK5DEdk6axgfPexlMk77R\n' +
        '5Jfgj1fvKBiLWbBa+MYJeIRkEWNkshU9GAOIeBiuD5QMsya6MiuB6FC+7d8PNCIU+3QXSvmIagnp\n' +
        'rpa0vVCoq/seetkyQYFa6nEwm6mKUMoOeQm+DezI+jQTnN4erKSrtAZyHgPW7jRi2la2xiCmbM6UcEj7LQIDAQAB\n'+
        '-----END PUBLIC KEY-----');
    otherKey.setOptions({encryptionScheme: 'pkcs1'});//就是增加这一行代码。
    let encrypted = otherKey.encrypt(value, 'base64');
    // encrypted = encodeURIComponent(encrypted);
    return encrypted;

};

export const getDatetime = function (dateTime) {
    var d = dateTime? new Date(dateTime) : new Date();
    var year = d.getFullYear();
    var month = change(d.getMonth() + 1);
    var day = change(d.getDate());
    var hour = change(d.getHours());
    var minute = change(d.getMinutes());
    var second = change(d.getSeconds());
    function change(t) {
        if (t < 10) {
            return "0" + t;
        } else {
            return t;
        }
    }
    var time = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    return time;
};




// WEBPACK FOOTER //
// ./src/core/appUtils.js